import module from './index'

let moduleName = 'module->' + module.info.name;

const routes = [
    {
        path: module.info.name,
        name: moduleName,
        component: () => import('./View.vue'),
        children: [
            {
                path: 'lcr',
                name: moduleName + '->lcr',
                component: () => import('./lcr/View.vue'),
                children: [
                    {
                        path: 'report',
                        name: moduleName + '->lcr->report',
                        component: () => import('./lcr/report/View.vue'),
                        children: [
                            {
                                path: ':listPage',
                                name: moduleName + '->lcr->report->list->page',
                                component: () => import('./lcr/report/page/View'),
                            }
                        ]
                    }
                ]
            },
            {
                path: ':entityTitle',
                name: moduleName + '->view',
                component: () => import('./view/View.vue'),
            }
        ]
    }
];

export default routes
